const ContactLinkType = `
  id
  description
  updatedAt
`;

export default ContactLinkType;
